module.exports = __webpack_public_path__ + "img/activities-3.30e52ec2.jpg";